import { createRoute } from '@/utils/routing'

export const FEE_GROUP_LIST_ROUTE = 'fees-groups'
export const FEE_GROUP_VIEW_ROUTE = 'fees-groups-id'
export const FEE_GROUP_EDIT_ROUTE = 'fees-groups-id-edit'
export const FEE_GROUP_CREATE_ROUTE = 'fees-groups-create'

function createRouteWithId (name, id, options) {
  if (id != null) {
    return createRoute(name, {
      params: { ...options.params, id },
      query: options.query
    })
  }
}

export function createFeeGroupListRoute (options = {}) {
  return createRoute(FEE_GROUP_LIST_ROUTE, options)
}

export function createFeeGroupViewRoute (id, options = {}) {
  return createRouteWithId(FEE_GROUP_VIEW_ROUTE, id, options)
}

export function createFeeGroupEditRoute (id, options = {}) {
  return createRouteWithId(FEE_GROUP_EDIT_ROUTE, id, options)
}

export function createFeeGroupCreateRoute (options = {}) {
  return createRoute(FEE_GROUP_CREATE_ROUTE, options)
}
